import React, { useState } from 'react';
import { MapPin, Building2, Globe, ChevronRight } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

const OfficesSection = () => {
  const { t, currentLang } = useLanguage();
  const [activeOffice, setActiveOffice] = useState(null);

  const offices = [
    {
      id: 'singapore',
      city: currentLang === 'ru' ? 'Сингапур' : currentLang === 'ar' ? 'سنغافورة' : 'Singapore',
      region: t.asia,
      address: '150 S Bridge Rd, #06-04A, Fook Hai Building',
      postal: 'Singapore 058727',
      name: 'Singapore Business Centre',
      flag: '🇸🇬'
    },
    {
      id: 'dubai',
      city: currentLang === 'ru' ? 'Дубай' : currentLang === 'ar' ? 'دبي' : 'Dubai',
      region: t.middleEast,
      address: 'The Offices 2, One Central – Trade Center Second',
      postal: 'Sheikh Zayed Road, Dubai',
      name: 'World Trade Center District',
      flag: '🇦🇪'
    },
    {
      id: 'london',
      city: currentLang === 'ru' ? 'Лондон' : currentLang === 'ar' ? 'لندن' : 'London',
      region: t.europe,
      address: '47-49 Park Royal Rd',
      postal: 'London, NW10 7LQ, UK',
      name: 'Premier Business Centre',
      flag: '🇬🇧'
    },
    {
      id: 'newyork',
      city: currentLang === 'ru' ? 'Нью-Йорк' : currentLang === 'ar' ? 'نيويورك' : 'New York',
      region: t.northAmerica,
      address: '9 West 57th St',
      postal: 'New York, NY 10019, USA',
      name: 'Solow Building',
      flag: '🇺🇸'
    },
    {
      id: 'sanfrancisco',
      city: currentLang === 'ru' ? 'Сан-Франциско' : currentLang === 'ar' ? 'سان فرانسيسكو' : 'San Francisco',
      region: t.northAmerica,
      address: '50 Fremont St',
      postal: 'San Francisco, CA 94105, USA',
      name: 'Salesforce West',
      flag: '🇺🇸'
    },
    {
      id: 'delhi',
      city: currentLang === 'ru' ? 'Нью-Дели' : currentLang === 'ar' ? 'نيودلهي' : 'New Delhi',
      region: t.southAsia,
      address: '402, Statesman House, Barakhamba',
      postal: 'New Delhi – 110001, India',
      name: 'Statesman House Business Centre',
      flag: '🇮🇳'
    }
  ];

  return (
    <section id="offices" className="offices-section">
      <div className="section-container">
        <div className="section-header centered">
          <div className="offices-badge">
            <Globe size={20} />
            <span>{t.officesBadge}</span>
          </div>
          <h2 className="section-title">{t.officesTitle}</h2>
          <p className="section-subtitle">{t.officesSubtitle}</p>
        </div>

        <div className="offices-grid">
          {offices.map((office) => (
            <div
              key={office.id}
              className={`office-card ${activeOffice === office.id ? 'active' : ''}`}
              onMouseEnter={() => setActiveOffice(office.id)}
              onMouseLeave={() => setActiveOffice(null)}
              data-testid={`office-card-${office.id}`}
            >
              <div className="office-header">
                <span className="office-flag">{office.flag}</span>
                <div className="office-location">
                  <h3 className="office-city">{office.city}</h3>
                  <span className="office-region">{office.region}</span>
                </div>
              </div>

              <div className="office-details">
                <div className="office-name">
                  <Building2 size={16} />
                  <span>{office.name}</span>
                </div>
                <div className="office-address">
                  <MapPin size={16} />
                  <div>
                    <p>{office.address}</p>
                    <p className="office-postal">{office.postal}</p>
                  </div>
                </div>
              </div>

              <div className="office-hover-indicator">
                <ChevronRight size={20} />
              </div>
            </div>
          ))}
        </div>

        <div className="offices-stats">
          <div className="office-stat">
            <span className="stat-number">6</span>
            <span className="stat-text">{t.offices}</span>
          </div>
          <div className="office-stat">
            <span className="stat-number">4</span>
            <span className="stat-text">{t.continents}</span>
          </div>
          <div className="office-stat">
            <span className="stat-number">80+</span>
            <span className="stat-text">{t.countriesCoverage}</span>
          </div>
          <div className="office-stat">
            <span className="stat-number">24/7</span>
            <span className="stat-text">{t.support247}</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default OfficesSection;
